











import CommonBase from "./components/CommonBase";
import {Component, Inject, Watch} from "vue-property-decorator";
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import Scaffold from "@/components/scaffold/Scaffold.vue";
import ErrorHandler from "@/components/ErrorHandler.vue";
import BaseApi from "@/store/modules/base";
import {queryParams} from "@/modules/utils";
import {routes} from "@/router";
import {SnackMsg} from "@/modules/models";
import SnackEvent from "@/modules/SnackEvent";

// Global js in index.html
declare function errorHandler(err: any);

@Component({
  components: {
    "at-breadcrumbs": Breadcrumbs,
    "at-scaffold": Scaffold,
    "at-error-handler": ErrorHandler,
  }
})
export default class App extends CommonBase {
  @Inject()
  baseApi!: BaseApi;

  get routes() {
    return routes;
  }

  get routeTitle() {
    const route = this.$route;
    return route.meta && route.meta.title || "";
  }

  @Watch("$route", {immediate: true})
  onRouteChanged() {
    if(this.$route) {
      if (this.routeTitle.length > 0) {
        document.title = `Anleggsterminal - ${this.routeTitle}`;
      }
      const orgnum = Number(this.$route.query["orgnum"]) || 0;
      const currentOrgnum = this.baseApi.company != null ? this.baseApi.company.orgNum : -1;
      if (orgnum > 0 && orgnum != currentOrgnum) {
        //change baseApi company
        this.baseApi.loadCompany(orgnum);
      } else if (orgnum == 0 && currentOrgnum > 0) { // Reflect current orgnum into url
        const q = this.$route.query;
        q["orgnum"] = `${currentOrgnum}`;
        window.history.replaceState({}, document.title, queryParams(q));
      }
    }
  }

  snackMsg: SnackMsg = new SnackMsg("");
  get showSnack() {
    return this.snackMsg.msg.length > 0;
  }
  set showSnack(v: boolean) {
    if(!v) {
      this.snackMsg = new SnackMsg("");
    }
  }
  newSnack(snackMsg: string | SnackMsg) {
    this.snackMsg = snackMsg instanceof SnackMsg ? snackMsg : new SnackMsg(snackMsg);
  }

  mounted() {
    // Remove the error handler in index.html since the one in at-error-handler is initialized now
    window.removeEventListener("error", errorHandler);
  }

  created() {
    window.addEventListener(SnackEvent.eventName, (e: Event) => {
      // Used to have instanceof check for SnackEvent here, but it doesn't work on safari, so do property check instead.
      if(e["snack"] !== undefined) {
        const se: SnackEvent = e as SnackEvent;
        this.newSnack(se.snack);
      } else {
        const detail = e["detail"];
        if(detail) {
          this.newSnack(detail);
        } else {
          throw new Error(`Could not get snack message detail for event ${SnackEvent.eventName}`);
        }
      }
    });
  }
}

